import React from "react";
import { Link } from "react-router-dom";
import styles from "./ToolChips.module.css";

const PlayIcon = () => (
  <div className={styles.playIcon} aria-hidden="true">
    <svg viewBox="0 0 68 48" xmlns="http://www.w3.org/2000/svg">
      <path
        className={styles.playIconBg}
        d="M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55c-2.93.78-4.63 3.26-5.42 6.19C.06 13.05 0 24 0 24s.06 10.95 1.48 16.26c.78 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.64-3.26 5.42-6.19C67.94 34.95 68 24 68 24s-.06-10.95-1.48-16.26z"
      />
      <path d="M 45,24 27,14 27,34" fill="#fff" />
    </svg>
  </div>
);

const ToolChips = ({ title, items = [], className = "" }) => {
  return (
    <section className={`${styles.wrapper} ${className}`}>
      {title && (
        <>
          <h2 className={styles.title}>{title}</h2>
          <div className={styles.divider} />
        </>
      )}

      <div className={styles.chipsRow}>
        {items.map((item) => (
          <Link
            key={item.name}
            to={item.path}
            className={styles.chip}
          >
            <div className={styles.content}>
              <span className={styles.chipLabel}>
                {item.name}
              </span>

              {item.thumbnail ? (
                <div className={styles.thumbnailWrapper}>
                  <img
                    src={item.thumbnail}
                    alt={item.name}
                    className={styles.thumbnail}
                  />
                  <PlayIcon />
                </div>
              ) : (
                <div className={styles.comingSoon}>
                  Coming Soon
                </div>
              )}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default ToolChips;